const ContentfulEntryIDs = Object.freeze({
  FAQS: '1YjrZN5eG4doxZZsDTMYSj',
  PAGE_ABOUT: '4npwv5RxjWGcvDhZLlnrR4',
  PAGE_HOME: '2sNUmEw6nDwFFMNS0VKyaE',
  PAGE_INSURANCE: '3fPkncK6AZU8IZemZiWaRq',
  PAGE_PRIVACY: '1HbZepzN2hdYjqQNofer2H',
  PAGE_TOS: '6Q9rm4GQJ4eoj9Vbj94tNx',
  PLATFORM_FEATURES: '2sNUmEw6nDwFFMNS0VKyaE',
  PRICE_LEGAL: '2r9ebBWK96lqaXc9UyapMR',
  SALES_CALL_AVAILABILITY: '29Ovuy236s168HyRCg3C7e',
});

export default ContentfulEntryIDs;
